import styled from "@emotion/styled";
import React from "react";
import TextSimple from "../typography/text-simple/TextSimple";
interface ItemOptionProps {
  icon: React.ReactNode;
  label: string;
  onClick: (x: any) => void;
  extraHiddenComponent?: boolean;
}
function ItemOption(props: ItemOptionProps) {
  return (
    <>
      <ContentOption>
        {props.icon && props.icon}
        {props.label && (
          <TextSimple color="gray" font="gotham" size="label" weight="700">
            {props.label}
          </TextSimple>
        )}
      </ContentOption>
    </>
  );
}

export default ItemOption;

const ContentOption = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  svg {
    // width: 15px;
    // height: 15px;
    stroke: #838993;
  }
`;
